const state = {
  complexes: "",
  activeComplex: null,
  canEdit: true,
  filterApartments: [],
};

const getters = {
  getComplexes: (state) => state.complexes,
  getCanEdit: (state) => state.canEdit,
  getActiveComplex: (state) => state.activeComplex,
  getComplexById: (state) => (id) =>
    state.complexes
      ? state.complexes.find((complex) => complex.id === id)
      : null,
  getFilterApartments: (state) => state.filterApartments,
};

const mutations = {
  listComplexes(state, complexes) {
    state.complexes = complexes;
  },
  ADD_COMPLEX(state, payload) {
    state.complexes.push(payload);
  },
  toggleCanEdit(state, payload) {
    state.canEdit = payload;
  },
  SET_ACTIVE_COMPLEX(state, complex) {
    state.activeComplex = complex;
  },
  SET_FILTER_APARTMENTS(state, apartments) {
    state.filterApartments = apartments;
  },
};

const actions = {
  setActiveComplex({ commit, getters }, complexId) {
    const complex = getters.getComplexById(parseInt(complexId));
    if (complex) {
      commit("SET_ACTIVE_COMPLEX", complex);
    }
  },
  ADD_COMPLEX({ commit }, complex) {
    commit("ADD_COMPLEX", complex);
  },
  setFilterApartments({ commit }, apartments) {
    commit("SET_FILTER_APARTMENTS", apartments);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/complexes.js